import { useParams, useNavigate } from "react-router-dom";
import { servicios } from "../data/servicios";
import styles from "./ServicioDetalle.module.css";

export default function ServicioDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const servicio = servicios.find((s) => s.id === id);

  if (!servicio)
    return <p className={styles.notFound}>Servicio no encontrado</p>;

  return (
    <div className={styles.container}>
      <button className={styles.volver} onClick={() => navigate("/")}>
        ← Volver
      </button>

      <div className={styles.header}>
        <div className={styles.icon}>{servicio.icon}</div>
        <h1 className={styles.titulo}>{servicio.titulo}</h1>
      </div>

      <p className={styles.descripcion}>{servicio.descripcion}</p>
      <ul className={styles.lista}>
        {servicio.contenido.map((item, index) => (
          <li key={index} className={styles.item}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}
